
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.666 3.333H3.333c-.92 0-1.667.748-1.667 1.667v10c0 .92.748 1.667 1.667 1.667h13.333c.92 0 1.667-.748 1.667-1.667V5c0-.92-.748-1.667-1.667-1.667zm0 1.667v.426l-6.667 5.186-6.666-5.185V5h13.333zM3.333 15V7.537l6.155 4.787a.828.828 0 001.023 0l6.155-4.787.002 7.463H3.333z"}})])
          )
        }
      }
    